import * as React from 'react';


export default () => <div className="mb-30">
  You are trying to remove weekend item. All data will be lost.
</div>